import { RecordingState } from "../pages";
import { EventEmitter } from 'events';
import { TranscriptionEvent, ChangeEvent } from "./utils";
import Dispatcher from '../dispatcher';
import { RecordingActionTypes, MicrophoneState } from "../common/enums/recordingEnums";

const defaultState: RecordingState = {
    isRecorderReady: false,
    isPaused: false,
    microphoneState: MicrophoneState.Pending,
    warningDismissed: false,
    privacyDisclaimerClosed: false,
    shouldShowMicrophonePermissionRetryDialog: false
}

class RecordingStore extends EventEmitter {
  private state: RecordingState;

  constructor() {
    super();

    this.state = this.getInitialState();
  }

  private getInitialState = (): RecordingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, defaultState);
  }

  public getState = (): RecordingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, this.state);
  }

  public handleActions = (action: Event): void => {
    switch(action.type) {
      case RecordingActionTypes.SetRecorderReadyAction:
        this.state.isRecorderReady =  (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.SetRecorderIsPaused:
        this.state.isPaused = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.RevertStateAction:
        this.state = this.getInitialState();
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.SetMicrophoneStateAction:
        this.state.microphoneState =  (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.SetWarningDismissedAction:
        this.state.warningDismissed =  (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.SetPrivacyDisclaimerClosed:
        this.state.privacyDisclaimerClosed = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case RecordingActionTypes.SetMicrophonePermissionRetryDialog:
        this.state.shouldShowMicrophonePermissionRetryDialog = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      }
  }
}

const recordingStore = new RecordingStore;
Dispatcher.register(recordingStore.handleActions);
export default recordingStore;